<template>
  <div>
    <vs-popup title="Vincular Dashes" :active.sync="addTenantPopupActive">
      <TenantSlimList
        :tenants="tenants"
        :chosenTenants="chosenTenants"
        :addTenantPopupActive="addTenantPopupActive"
        @setTenants="setTenants"
      />
    </vs-popup>

    <vs-sidebar
      click-not-close
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="add-new-data-sidebar items-no-padding"
      spacer
      v-model="isSidebarActiveLocal"
    >
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>Adicionar Usuario</h4>
        <feather-icon
          icon="XIcon"
          @click.stop="isSidebarActiveLocal = false"
          class="cursor-pointer"
        ></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>

      <VuePerfectScrollbar
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
        ref="formPS"
      >
        <form @submit.prevent="addInstances" autocomplete="off">
          <div class="p-6" ref="form">
            <!-- NAME -->
            <vs-input
              label="Nome"
              v-model="user.name"
              class="mt-5 w-full"
              name="name"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('name')"
            >
              {{ errors.first('name') }}
            </span>

            <!-- EMAIL -->
            <vs-input
              label="Email"
              v-model="user.email"
              class="mt-5 w-full"
              name="email"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('email')"
            >
              {{ errors.first('email') }}
            </span>

            <!-- PASSWORD -->
            <vs-input
              label="Senha"
              :type="showPassword ? 'text' : 'password'"
              v-model="user.password"
              class="mt-5 w-full"
              name="password"
              v-validate="this.user.id === null || this.user.id === undefined ? 'required|min:8' : 'min:8'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('password')"
            >
              {{ errors.first('password') }}
            </span>

            <!-- CORFIME PASSWORD -->
            <vs-input
              label="Confirme a senha"
              :type="showPassword ? 'text' : 'password'"
              v-model="user.confirmPassword"
              class="mt-5 w-full"
              name="confirm_password"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('password')"
            >
              {{ errors.first('password') }}
            </span>
            <vs-checkbox class="mt-2" v-model="showPassword">
              Exibir Senha
            </vs-checkbox>
            <password-strong :password="user.password"></password-strong>

            <div class="mt-5 mb-5">
              <label class="vs-input--label">Permissão</label>
              <v-select
                v-model="user.role"
                :options="roleOptions"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full"
                name="role"
                v-validate="'required'"
                placeholder=" "
                :disabled="roleOptions.length === 0"
                :clearable="false"
                :searchable="true"
                :reduce="option => option.value"
                label="label"
                @input="onRoleChange"
              />
              <div v-if="roleOptions.length === 0" class="text-warning text-sm mt-2">
                Carregando permissões...
              </div>
            </div>
            <span
              class="text-danger text-sm"
              v-show="errors.has('role')"
            >
              {{ errors.first('role') }}
            </span>

            <div class="w-full  mt-5 mb-5">
              <h3>Dashes</h3>
              <ul class="mt-3">
                <li>
                  <vs-radio 
                    v-model="chooseTenants" 
                    vs-name="chooseTenants" 
                    vs-value="none"
                  >
                    Nenhuma Dash
                  </vs-radio>
                </li>

                <li>
                  <vs-radio 
                    v-model="chooseTenants" 
                    vs-name="chooseTenants" 
                    vs-value="choose"
                  >
                    Escolher Dashes
                  </vs-radio>
                </li>
              </ul>

              <div v-if="chooseTenants === 'choose'">
                <vs-chip
                  :key="`tenant-${index}`"
                  @click="removeTenant(tenant)"
                  v-for="(tenant, index) in chosenTenants"
                  closable
                  color="primary"
                  class="mt-3 mr-3"
                  style="font-size: 0.9rem;"
                >
                  {{ tenant.fqdn.split(".")[0] }}
                </vs-chip>

                <vs-chip
                  @click="addTenantPopupActive = true"
                  closable
                  close-icon="add"
                  class="mt-3 mr-3"
                  style="font-size: 0.9rem;"
                >
                  Vincular Dash
                </vs-chip>
              </div>

              <br v-if="chooseTenants === 'choose'">
            </div>
          </div>
        </form>
      </VuePerfectScrollbar>

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button class="mr-6" @click="addData" :disabled="!isFormValid">
          Adicionar
        </vs-button>
        <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">
          Cancelar
        </vs-button>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import PasswordStrong from "@/components/password-strong/password-strong.vue";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import role from '../../http/requests/role/index';
import TenantSlimList from './TenantSlimList.vue';
import { filterPassword } from '@/utils';
import { mapGetters } from 'vuex';
import vSelect from 'vue-select';

export default {
  name: 'user-view-sidebar',
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      emailCurrent: '',
      roleList: [],
      showPassword: false,
      chooseTenants: 'none',
      chosenTenants: [],
      addTenantPopupActive: false
    }
  },
  computed: {
    ...mapGetters([
      'token',
      'users',
      'tenants'
    ]),
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar');
        }
      }
    },
    isFormValid() {
      const hasErrors = this.errors.any();
      const hasRequiredFields = this.user.name && this.user.email && this.user.password && this.user.confirmPassword;
      const hasRole = this.user.role && this.user.role !== '';
      
      return !hasErrors && hasRequiredFields && hasRole;
    },
    roleOptions() {
      if (!this.roleList || !Array.isArray(this.roleList) || this.roleList.length === 0) {
        return [];
      }
      
      const options = this.roleList.map(role => {
        return {
          label: role.display_name || role.name || 'Sem nome',
          value: role.display_name || role.name || 'Sem nome'
        };
      });
      return options;
    }
  },
  methods: {
    onRoleChange(value) {
      this.user.role = value;
      this.$validator.validate('role');
    },
    removeTenant(tenant) {
      this.chosenTenants = this.chosenTenants.filter(item => item.website_id !== tenant.website_id);
    },
    setTenants(tenants) {
      this.addTenantPopupActive = false;
      this.chosenTenants = tenants;
    },
    verify() {
      const permissions = localStorage.getItem('permissions');
      const twoFactor   = localStorage.getItem('twoFactor');
      if (!permissions && !twoFactor) {
        this.$router.push('/user-settings');
      } else if(!permissions && twoFactor) {
        this.$router.push('/two-factor');
      }
    },
    async addData() {
      let emailAlreadyExists = false;
      this.users.forEach(element => {
        if (element.email === this.user.email) {
          emailAlreadyExists = true;
        }
      });

      const passwordStrength = filterPassword(this.user.password);
      if (passwordStrength <= 75) {
        return this.$vs.notify({
          color: 'danger',
          title: 'Senha inválida!',
          text: 'A senha precisa ser forte para que as alterações sejam salvas'
        });
      }
      else if (emailAlreadyExists) {
        this.$vs.notify({
          title:'Erro',
          text:'O email em questão já está cadastrado',
          color:"danger"
        })
        return false;
      }
      else if (this.user.name == '' || this.user.email == '' || this.user.password == '' || this.user.confirmPassword == '') {
        this.$vs.notify({
          title:'Erro',
          text:'Todos os campos obrigatórios devem ser preenchidos',
          color:"danger"
        })
        return false;
      }
      else if (!this.user.role || this.user.role === '') {
        this.$vs.notify({
          title:'Erro',
          text:'É obrigatório selecionar uma permissão',
          color:"danger"
        })
        return false;
      }
      else if (this.user.password === this.user.confirmPassword) {
        try {
          const websiteIds = [];
          this.chosenTenants.forEach(item => websiteIds.push(item.website_id));

          this.$vs.loading();
          await this.$store.dispatch('addUser', {
            token: this.token,
            data: {
              role: this.user.role,
              name: this.user.name,
              email: this.user.email,
              password: this.user.password,
              website_ids: websiteIds.length && this.chooseTenants !== 'none' ? websiteIds : null
            }
          });

          await this.$store.dispatch('getAllUsers', { token: this.token });
          this.isSidebarActiveLocal = false;
          this.$vs.loading.close();
          return this.$vs.notify({
            title:'Sucesso!!',
            text:'Usuario adicionado com sucesso',
            color:"success"
          });
        } catch(Exception) {
          this.$vs.loading.close();
          return this.$vs.notify({
            title:'Erro',
            text:'Ocorreu um erro inesperado, entre em contato com nossa equipe',
            color:"danger"
          })
        }
      } else {
        return this.$vs.notify({
          title:'Erro',
          text:'As senhas devem ser iguais',
          color:"danger"
        });
      }
    },
    async getTenants() {
      this.$store.dispatch('getAllTenants', 
        { token: this.token }
      )
    },
    async roles() {
      await role.fetchRoles()
      .then(response => {
        this.roleList = response.data;
      })
      .catch(Exception => {
        console.log(Exception);
      });
    }
  },
  components: {
    VuePerfectScrollbar,
    PasswordStrong,
    TenantSlimList,
    vSelect
  },
  async mounted() {
    await this.roles();
    await this.getTenants();
    this.verify();
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
